import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { Button } from '../../../components/common/button/button';
import { AuthApiService } from '../../../services/apis/auth-api.service';
import { ApiException, ApiStatus } from '../../../services/apis/status';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'app-signup-verification-page',
  imports: [Button, RouterModule],
  templateUrl: './signup-verification-page.html',
  styleUrl: './signup-verification-page.scss',
})
export class SignupVerificationPage {
  token: string = '';
  nonce: string = '';
  loading: boolean = false;
  constructor(
    private title: TitleService,
    private route: ActivatedRoute,
    private authApi: AuthApiService,
    private router: Router,
  ) {
    this.title.setTitle('Verifying your email address');
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'] ?? '';
      this.nonce = params['nonce'] ?? '';
      this.signupVerification();
    });
  }

  get appname(): string {
    return environment.appname;
  }

  notFound: boolean = false;
  isExpired: boolean = false;
  isUsed: boolean = false;
  isVerified: boolean = false;

  async signupVerification() {
    try {
      this.loading = true;
      this.isVerified = await this.authApi.signupVerification({
        token: this.token,
        nonce: this.nonce,
      });
      if (this.isVerified) {
        this.title.setTitle(
          'You have successfully verified your email address',
        );
      }
    } catch (error) {
      this.isVerified = false;
      if (error instanceof ApiException) {
        if (error.status === ApiStatus.USER_EMAIL_TOKEN_NOT_FOUND) {
          this.notFound = true;
          this.title.setTitle('Your verification link is invalid');
        } else if (error.status === ApiStatus.USER_EMAIL_TOKEN_EXPIRED) {
          this.isExpired = true;
          this.title.setTitle('Your verification link has expired');
        } else if (error.status === ApiStatus.USER_EMAIL_TOKEN_USED) {
          this.isUsed = true;
          this.title.setTitle('Your verification link has been used');
        }
      }
    } finally {
      this.loading = false;
    }
  }
}
